import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/promocategorycommision`;


const ApiPromocategorycommision = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllPromoCategoryCommission: () => {
    const url = `${baseServiceUrl}/getPromoCategoryCommissionList`;
    return ServiceApi.get(url);
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  getCommisionByPromoCategoryId: (id) => {
    const url = `${baseServiceUrl}/getCommisionByPromoCategoryId?id=${id}`;
    return ServiceApi.get(url);
  },
  addOrEditPromoCategoryCommision: (params) => {
    const url = `${baseServiceUrl}/addOrEditPromoCategoryCommision`;
    return ServiceApi.post(url, params);
  },
  updatePromoCategoryCommisionStatusOrIsDefault: (params) => {
    const url = `${baseServiceUrl}/updatePromoCategoryCommisionStatusOrIsDefault`;
    return ServiceApi.put(url, params);
  },
  addAndEditPromoCategoryCommisionAmusmentServiceCommand: (params) => {
    const url = `${baseServiceUrl}/addAndEditPromoCategoryCommisionAmusmentServiceCommand`;
    return ServiceApi.post(url, params);
  },
  addOrEditPromoCategoryCommisionAmusmentServiceByExcel: (formData) => {
    const url = `${baseServiceUrl}/addOrEditPromoCategoryCommissionAmusmentServiceByExcel`;
    return ServiceApi.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  update: (id, data) => {
    const url = `${baseServiceUrl}/update-amusementGroup`;
    return ServiceApi.put(url, data);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAllGroups: () => {
    const url = `${baseServiceUrl}/getAllAmusementGroups`;
    return ServiceApi.get(url);
  },
  copyPromoCategoryCommision: (params) => {
    const url = `${baseServiceUrl}/CopyPromoCategoryCommision`;
    return ServiceApi.post(url, params);
  },
  getPromoCategoryCommissionAmusementServiceById: (id) => {
    const url = `${baseServiceUrl}/getPromoCategoryCommissionAmusementServiceById/${id}`;
    return ServiceApi.get(url);
  },
};

export default ApiPromocategorycommision;